// extracted by mini-css-extract-plugin
export default {"contentBreak":"contentBreak-module--contentBreak--ed14b","contentBreakWrapper":"contentBreak-module--contentBreakWrapper--ec41f"};